import React, { useState, useEffect } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'
import 'swiper/css'


function Cloathing() {


    const [index, setIndex] = useState(0)
    const [tshirt, setTshirt] = useState([
        '././images/tshirt1-min.jpg',
        '././images/tshirt3-min.jpg',
        '././images/tshirt2-min.jpg'
    ])

    const checkNumber = (number) => {
        if (number > 2) {
            return 0
        }
        if (number < 0) {
            return 2
        }
        return number
    }

    const nextPerson = () => {
        setIndex((index) => {
            let newIndex = index + 1
            return checkNumber(newIndex)
        })
    }
    const prevPerson = () => {
        setIndex((index) => {
            let newIndex = index - 1
            return checkNumber(newIndex)
        })
    }


    return (
        <section id='cloathing' className='page4'>
            <div className='allclothes'>
                <h3 className='clothingbrand'>Clothing Brand</h3>
                <div className='rotatelogo'>
                    <img className='horilogo' src='././images/yataylogo.png' />
                </div>
                <div className='tshirts'>
                    <div className='rightleft-btn'>
                        <button className='change-btn left-btn' onClick={prevPerson}>
                            <FaChevronLeft />
                        </button>
                        <button className='change-btn right-btn' onClick={nextPerson}>
                            <FaChevronRight />
                        </button>
                    </div>
                    <img className='clothes' id='tshirt1' src={tshirt[index]} data-tilt />
                </div>
                <h4 className='comingsoon'>coming soon</h4>
            </div>
        </section>
    )
}
export default Cloathing